import { render, staticRenderFns } from "./LivesVideoOrder.vue?vue&type=template&id=d2ec56cc&scoped=true&"
import script from "./LivesVideoOrder.vue?vue&type=script&lang=js&"
export * from "./LivesVideoOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ec56cc",
  null
  
)

export default component.exports